import React, { useContext } from "react";
import { GoSearch } from "react-icons/go";
import { Link } from "react-router-dom";
import IconConnection from "../../../../components/iconConnection/iconConnection";
import { AppContext } from "../../../../context/AppContext";
import logoWhite from "../../../../image/logo/logoWhite.svg";
import { TopBarType } from "../homeTopBar";
import topBarImg from "../../../../image/topBar/topBarImg_low.webp";
import { trackSearchOpen } from "../../../../components/analytics/hookAnalytics";


interface TopBarHeroProps {
  type: TopBarType;
  resetHome:() => void,
  useMainFilter:string,
}

const TopBarHero: React.FC<TopBarHeroProps> = ({ type ,useMainFilter, resetHome }) => {
  const {setOpenSearchPage} = useContext(AppContext);

  return (
    <div className="topBarHero">
      <div className="topBarHeroImage">
        <img className="topBarHeroImg" src={topBarImg} alt="" loading="eager" decoding="async" fetchPriority="high" />
        <div className="topBarHeroHeader">
          <Link to="/" className="containerLogo" onClick={resetHome}>
            <img className="logoTopBar" src={logoWhite} loading="eager" decoding="async" alt="QuelResto"/>
          </Link>

          <IconConnection />
        </div>
        {type === "primary" && (
          <div className="topBarHeroCatchPhrase largeText">
            <span className="goldText">Le bon restaurant,</span>
            <span className="whiteText">selon vos envies.</span>
          </div>
        )}
        <div className={`topBarHeroBottom ${type} ${useMainFilter === '' ? 'isSimpleScnd' : 'isLongScnd'}`}>
          <div className={`topBarMainButton smallText pointer flexAllCenter ${type} ${useMainFilter === '' ? 'isSimpleScnd' : 'isLongScnd'}`} onClick={() => {trackSearchOpen({action: type === "primary" ? "launch" : "modify",source: "hero"}); setOpenSearchPage(true);}}>
            <GoSearch className="iconFirst" size={18}/>
            <div className="scndPart flexAllCenter">
              {type === "primary"
                ? <span>Lancer ma recherche</span>
                : useMainFilter === '' ? 
                    <span>Modifier ma recherche</span> 
                    : <>
                      <span>{useMainFilter}</span>
                      <div>Modifier ma recherche</div>
                      <GoSearch className="iconScnd" size={18}/>
                    </>
              }
            </div>
          </div>
        </div>

        <div className="shadowTop"></div>
        <div className="shadowTopScnd"></div>
        <div className="shadowGlobalFirst"></div>
        <div className="shadowBottom"></div>
        <div className="shadowGlobalScnd"></div>
      </div>
    </div>
  );
};

export default TopBarHero;